import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import MenuItem from "@mui/material/MenuItem";
import dayjs from "dayjs";

import {
  course_demo_image,
  Teacher_Dashboard_Default_NEW,
  Teacher_Dashboard_Default,
  unarchive_btn,
} from "../../../../../../assets/images/images";

import StyledMenu from "../../../../../../components/StyleMenu";
import PaginationView from "../../../../../../components/Pagination/PaginationView";
import Card from "../course/Card";
import CourseDescriptionPreview from "../../../../../../context/CourseDescriptionPreview";
import DescriptionCoursePopup from "../course/DescriptionCoursePopup";

const ArchiveCourses = ({
  courses,
  toggleDeleteCourse,
  toggleArchiveCourse,
  setSelectedCourse,
  nextUrl,
  prevUrl,
  handlePageChange,
  totalPages,
  currentPage,
}) => {
  const navigate = useNavigate();
  const menuRef = useRef();
  const location = useLocation();
  const globalState = useSelector((state) => state.globalState);

  const currency_symbol = useSelector(
    (state) => state?.globalState?.currency_symbol,
  );

  const teacher_id = globalState?.teacher_details?.data?.teacher_id;

  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenuCourseId, setActiveMenuCourseId] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClick = (event, courseId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenuCourseId(courseId);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setAnchorEl(null);
        setActiveMenuCourseId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClose = () => {
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    setAnchorEl(null);
    setActiveMenuCourseId(null);
  };

  const onViewCourseClick = (course) => {
    navigate(`/course/${course.course_id}/view`, {
      state: { course, teacher_id, from: location.pathname },
    });
  };

  const onEditCourseClick = (course) => {
    navigate(`/course/${course.course_id}/edit`, {
      state: { course, teacher_id },
    });
  };

  const onDeleteClick = (courseId) => {
    setSelectedCourse(courseId);
    toggleDeleteCourse();
  };

  const onArchiveClick = (course) => {
    setSelectedCourse(course.name);
    toggleArchiveCourse(course);
  };

  const archiveCourses = courses;

  return (
    <>
      <div className="created-my-courses-container">
        {/* Loading state is now handled by TeacherDashboard */}
        {archiveCourses && archiveCourses.length > 0 ? (
          archiveCourses.map((course, index) => (
            <div key={course.course_id} className="created-my-courses-folder gap-6 bg-[#EDEDED] shadow-sm blur-sm">
              <div className="created-my-courses-folder-image-left-folder">
                <div
                  className="created-my-courses-folder-image "
                  onClick={() => onViewCourseClick(course)}
                >
                  <img src={course.image || course_demo_image} alt="" />
                </div>
              </div>
              <div className="created-my-courses-des-wrapper">
                <div className="created-my-courses-title-folder">
                  <div className="created-my-courses-title-wrapper justify-between">
                    <h2
                      className="w-full"
                      onClick={() => onViewCourseClick(course)}
                    >
                      {course.name}
                    </h2>
                    <p className="text-[#555555] font-light text-sm md:text-lg text-right w-full flex-nowrap cursor-default">
                      Archived{" "}
                      <img
                        className="h-3 w-3 md:h-5 md:w-5"
                        src={unarchive_btn}
                        alt="unarchive_btn"
                      />
                    </p>
                  </div>

                  {course.my_role !== "viewer" && (
                    <div className="edit-course-dropdown-menu-container ">
                      <div
                        className="edit-course-or-delete-course"
                        onClick={(e) => handleClick(e, course.course_id)}
                      >
                        <i className="fa-solid fa-ellipsis-vertical"></i>
                      </div>
                      <StyledMenu
                        id="demo-customized-menu"
                        anchorEl={anchorEl}
                        open={Boolean(
                          anchorEl && activeMenuCourseId === course.course_id,
                        )}
                        onClose={handleClose}
                        disableAutoFocusItem
                      >
                       { !course.is_archived && (<MenuItem
                          onClick={() => {
                            if (activeMenuCourseId === course.course_id) {
                              handleClose();
                              onEditCourseClick(course);
                            }
                          }}
                          disableRipple
                        >
                          <button
                            type="button"
                            className="course-edit-or-delete-folder"
                          >
                            <a href="#">
                              <i className="fa-solid fa-pencil"></i>
                            </a>
                            <p>Edit</p>
                          </button>
                        </MenuItem>)}
                        {course.my_role !== "viewer" &&
                          globalState.enabled_modules?.includes(
                            "year2year",
                          ) && (
                            <MenuItem
                              onClick={() => {
                                if (activeMenuCourseId === course.course_id) {
                                  handleClose();
                                  onArchiveClick(course);
                                }
                              }}
                              disableRipple
                            >
                              <button
                                type="button"
                                className="course-edit-or-delete-folder"
                              >
                                <a href="#">
                                  <img
                                    className="h-4 w-4"
                                    src={unarchive_btn}
                                    alt="archive_btn"
                                  />
                                </a>
                                <p>Unarchive Course</p>
                              </button>
                            </MenuItem>
                          )}
                        {((course.my_role === "owner")) && (
                          <MenuItem
                            onClick={() => {
                              if (activeMenuCourseId === course.course_id) {
                                handleClose();
                                onDeleteClick(course.course_id);
                              }
                            }}
                            disableRipple
                          >
                            <button
                              type="button"
                              className="course-edit-or-delete-folder"
                            >
                              <a href="#">
                                <i className="fa-solid fa-trash"></i>
                              </a>
                              <p>Delete</p>
                            </button>
                          </MenuItem>
                        )}
                      </StyledMenu>
                    </div>
                  )}
                </div>
                <div className="Students-courses-details-container">
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Students Enrolled</span>
                    <div className="Students-courses-details-counts">
                      <p>{course.enrolled_students}</p>
                      <p>
                        {course.enrolled_students > 1
                          ? "Students"
                          : "Student"}{" "}
                      </p>
                    </div>
                  </div>

                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Total Lessons</span>
                    <div className="Students-courses-details-counts">
                      <p>{course.lesson_count}</p>
                      <p>{course.lesson_count > 1 ? "Lessons" : "Lesson"} </p>
                    </div>
                  </div>
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Course Start Date</span>
                    <div className="Students-courses-details-counts">
                      <p>
                        {course.start_date !== null && course.start_date !== ""
                          ? dayjs(course.start_date).format("MMM DD, YYYY")
                          : "- -"}
                      </p>
                    </div>
                  </div>
                  <div
                    className="Students-courses-details-folder"
                    onClick={() => onViewCourseClick(course)}
                  >
                    <span>Course Expiry Date</span>
                    <div className="Students-courses-details-counts">
                      <p>
                        {course.end_date !== null && course.end_date !== ""
                          ? dayjs(course.end_date).format("MMM DD, YYYY")
                          : "- -"}
                      </p>
                    </div>
                  </div>
                  {/* Marketplace: Total Revenue display */}
                  {globalState.enabled_modules?.includes("marketplace") &&
                    course?.price !== null &&
                    course?.total_revenue !== null && (
                      <div className="Students-courses-details-folder">
                        <span>Total Revenue</span>
                        <div className="Students-courses-details-counts">
                          <p>
                            {course.total_revenue !== null &&
                              course.total_revenue !== "" && (
                                <p>
                                  {course?.currency_symbol ?? currency_symbol}{" "}
                                  {course.total_revenue}
                                </p>
                              )}
                          </p>
                        </div>
                      </div>
                    )}
                </div>
                {/* <p
                  className="Students-des"
                  onClick={() => onViewCourseClick(course)}
                > */}
                {/* {course.description} */}
                <CourseDescriptionPreview
                  description={course.description}
                  PopupComponent={DescriptionCoursePopup}
                  popupTitle="My Course Description"
                />
                {/* </p> */}
                <button
                  type="button"
                  onClick={() => onViewCourseClick(course)}
                  className="View-Course"
                >
                  View Course
                </button>
              </div>
            </div>
          ))
        ) : (
          <>
            <Card
              image={Teacher_Dashboard_Default_NEW}
              title="Craft an Interactive Course"
              description="Crafting an interactive course involves designing engaging lessons with quizzes and activities to actively involve students in the learning process"
            />
            <Card
              image={Teacher_Dashboard_Default}
              title="Build an Exciting Learning Journey"
              description="Crafting an exciting learning journey involves designing engaging educational experiences that captivate students and ignite their curiosity"
            />
          </>
        )}
      </div>
      {/* Add pagination back */}
      {totalPages > 1 && (
        <PaginationView
          totalPages={totalPages}
          next={nextUrl}
          previous={prevUrl}
          currentPage={currentPage}
          setCurrentPage={(page) => handlePageChange(null, page)}
        />
      )}
    </>
  );
};

export default ArchiveCourses;
